"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M22 20.4376C22 21.3008 21.3008 22 20.4376 22H3.5624C2.6992 22 2 21.3008 2 20.4376V3.5624C2 2.6992 2.6992 2 3.5624 2h16.8752C21.3008 2 22 2.6992 22 3.5624v16.8752z",
    fill: "#FFE812"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9947 4C7.8523 4 4.5 7.1375 4.5 10.9973c0 2.8571 1.185 4.2156 2.8078 5.4555h.0107v3.3531c0 .1078.0854.1941.1922.1941.0427 0 .0854-.0108.1174-.0431l2.8399-2.1348.064.0216c.4805.0862.9822.1401 1.4733.1401 4.1424 0 7.4947-3.1374 7.4947-6.9973C19.5 7.1267 16.1263 4 11.9947 4zm4.2277 6.1441c.2776.2911.4164.6792.4164 1.186v2.3935h-.9929v-2.2641c0-.5176-.2989-.7979-.7687-.7979-.5124 0-.854.3235-.854.9704v2.1024h-.9929V8.171h.9929v2.0809c.2348-.3666.6192-.5498 1.153-.5498.395 0 .7687.1509 1.0462.442zm-6.7366 2.6185c.7366 0 1.3558-.4421 1.548-1.1213l1.0783-.0108c-.2669 1.3262-1.2811 2.1887-2.637 2.1887-1.5694 0-2.8185-1.186-2.8185-2.8356S7.9056 8.148 9.475 8.148c1.3665 0 2.3914.8841 2.6477 2.2211h-1.0783c-.1602-.7332-.8114-1.186-1.5587-1.186-1.057 0-1.7616.7655-1.7616 1.8005v.0431c.0107.9704.8007 1.7467 1.7616 1.7359z"
  })];
};

exports.default = _default;